import Cookies, { CookieAttributes } from 'js-cookie';

export const domain = window.location.hostname.replace(/w+/g, '');
export const protocol = window.location.protocol.replace(/:/, '');

export function setCookie(
  name: string,
  value: string,
  options?: CookieAttributes,
) {
  Cookies.set(name, value, {
    domain,
    secure: true,
    sameSite: 'None',
    ...options,
  });
}

export function removeCookie(name: string, options?: CookieAttributes) {
  Cookies.remove(name, {
    domain,
    secure: true,
    sameSite: 'None',
    ...options,
  });
}

export function getCookie(name: string) {
  return Cookies.get(name);
}

export function getAllCookies() {
  return Cookies.get();
}
